export const fontMap = {
    opal: {
        chic: {
            primary: 'Abril Fatface',
            secondary: 'Cabin',
        },
        elegant: {
            primary: 'Playfair Display',
            secondary: 'IBM Plex Sans',
        },
        geometric: {
            primary: 'Poppins',
            secondary: 'DM Sans',
        },
        luxury: {
            primary: 'Noto Serif Display',
            secondary: 'Raleway',
        },
        modern: {
            primary: 'Inter',
            secondary: 'Inter',
        },
        super: {
            primary: 'Syne',
            secondary: 'Nunito',
        },
        urban: {
            primary: 'Oswald',
            secondary: 'Cardo',
        },
    },
};
//# sourceMappingURL=fonts.js.map